import React, { useState, useRef, useCallback } from 'react';
import { T } from '../../lib/tokens';

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxHeightPct?: number;
}

export function BottomSheet({ open, onClose, children, maxHeightPct = 92 }: Props) {
  const [dragY, setDragY] = useState(0);
  const dragStart = useRef<number | null>(null);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    dragStart.current = e.touches[0]!.clientY;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (dragStart.current === null) return;
    const delta = e.touches[0]!.clientY - dragStart.current;
    if (delta > 0) setDragY(delta);
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (dragY > 120) onClose();
    setDragY(0);
    dragStart.current = null;
  }, [dragY, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 200,
        background: 'rgba(10,20,40,0.4)',
        display: 'flex',
        alignItems: 'flex-end',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: T.paper,
          width: '100%',
          maxHeight: `${maxHeightPct}%`,
          borderRadius: '18px 18px 0 0',
          display: 'flex',
          flexDirection: 'column',
          transform: `translateY(${dragY}px)`,
          transition: dragY === 0 ? 'transform 0.3s cubic-bezier(0.32,0.72,0,1)' : 'none',
        }}
      >
        <div
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          style={{ padding: '10px 0 6px', display: 'flex', justifyContent: 'center', cursor: 'grab' }}
        >
          <div style={{ width: 40, height: 4, background: T.paperLine, borderRadius: 100 }} />
        </div>
        {children}
      </div>
    </div>
  );
}
